export default __webpack_public_path__ + "static/media/para-text-ic.720612a7.svg";